<template>
  <section>
    <div class="row">
      <div class="col-md-4">Total Time</div>
      <div class="col-md-2">
        <input
          type="number"
          class="form-control text-end"
          v-model="zone.totalMinutes"
          min="0"
          :disabled="!isEnabled"
          @blur="balanceZone"
          @change="balanceZone"
        />
      </div>
      <div class="col-md-1">mins</div>
      <div class="col-md-5"></div>
    </div>
    <div class="row mt-2">
      <div class="col-md-4">
        <ul class="custom-list">
          <li><span>Below Zone</span></li>
          <li>
            <span class="custom-range">{{ zone.belowRange }}</span>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <input
          type="number"
          class="form-control text-end"
          v-model="zone.belowPercent"
          min="0"
          max="100"
          :disabled="!isEnabled"
          @blur="balanceZone"
          @change="balanceZone"
        />
      </div>
      <div class="col-md-1">%</div>
      <div class="col-md-5">{{ zone.belowMinutes }} mins</div>
    </div>
    <div class="row mt-2">
      <div class="col-md-4">
        <ul class="custom-list">
          <li><span>In Zone</span></li>
          <li>
            <span class="custom-range">{{ zone.inRange }}</span>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <input
          type="number"
          class="form-control text-end"
          v-model="zone.inPercent"
          min="0"
          max="100"
          :disabled="!isEnabled"
          @blur="balanceZone"
          @change="balanceZone"
        />
      </div>
      <div class="col-md-1">%</div>
      <div class="col-md-5">{{ zone.inMinutes }} mins</div>
    </div>
    <div class="row mt-2">
      <div class="col-md-4">
        <ul class="custom-list">
          <li><span>Above Zone</span></li>
          <li>
            <span class="custom-range">{{ zone.aboveRange }}</span>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <input
          type="number"
          class="form-control text-end"
          v-model="zone.abovePercent"
          min="0"
          max="100"
          :disabled="!isEnabled"
          @blur="balanceZone"
          @change="balanceZone"
        />
      </div>
      <div class="col-md-1">%</div>
      <div class="col-md-5">{{ zone.aboveMinutes }} mins</div>
    </div>
    <div class="row mt-2">
      <div v-if="!isMultiple" class="col-md-4">Max HR</div>
      <div class="col-md-2">
        <input
          type="number"
          v-if="!isMultiple"
          class="form-control text-end"
          v-model="zone.maxHR"
          :disabled="!isEnabled"
          @blur="balanceZone"
          @change="balanceZone"
        />
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-5">
        <button
          v-if="isSave && !noSave"
          class="btn btn-danger btn-sm"
          :disabled="isDisabled"
          @click="save"
        >
          <i v-if="isDisabled" class="fas fa-spinner fa-spin"></i>
          save
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import Input from '../../Elements/Input.vue'
export default {
  components: { Input },
  name: 'cardio-goals',
  props: {
    zone: {
      type: Object,
      default: {
        totalMinutes: 0,
        belowMinutes: 0,
        inMinutes: 0,
        aboveMinutes: 0,
        belowPercent: 0,
        inPercent: 0,
        abovePercent: 0,
        belowRange: '',
        inRange: '',
        aboveRange: '',
        maxHR: 0,
      },
    },
    isEnabled: {
      type: Boolean,
      default: false,
    },
    noSave: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSave: false,
      isDisabled: false,
    }
  },
  mounted() {
    this.isDisabled = false
    this.isSave = false
  },
  methods: {
    roundUp(num, precision) {
      return Math.ceil(num * precision) / precision
    },
    balanceZone() {
      var diff = 0
      console.log('Balance Zone', this.zone)
      if (parseFloat(this.zone.belowPercent) > 100) {
        this.zone.belowPercent = 100
        this.zone.inPercent = 0
        this.zone.abovePercent = 0
      }
      if (
        parseFloat(this.zone.belowPercent) + parseFloat(this.zone.inPercent) >
        100
      ) {
        this.zone.inPercent = 0
      }
      if (parseFloat(this.zone.inPercent) > 100) {
        this.zone.inPercent = 0
      }
      if (parseFloat(this.zone.inPercent) > 0) {
        diff =
          100 -
          (parseFloat(this.zone.belowPercent) + parseFloat(this.zone.inPercent))
        this.zone.abovePercent = diff.toFixed(0)
      } else {
        diff = 100 - parseFloat(this.zone.belowPercent)
        this.zone.inPercent = diff.toFixed(0)
        this.zone.abovePercent = 0
      }
      var belowZoneMinutes = this.roundUp(
        parseFloat(this.zone.totalMinutes) *
          (parseFloat(this.zone.belowPercent) / 100),
        10
      )
      var inZoneMinutes = this.roundUp(
        parseFloat(this.zone.totalMinutes) *
          (parseFloat(this.zone.inPercent) / 100),
        10
      )
      var aboveZoneMinutes = this.roundUp(
        parseFloat(this.zone.totalMinutes) *
          (parseFloat(this.zone.abovePercent) / 100),
        10
      )
      var tempTotal = belowZoneMinutes + inZoneMinutes + aboveZoneMinutes
      var tempDiff = parseFloat(this.zone.totalMinutes) - tempTotal
      aboveZoneMinutes = aboveZoneMinutes + tempDiff
      this.zone.belowMinutes = belowZoneMinutes.toFixed(1)
      this.zone.inMinutes = inZoneMinutes.toFixed(1)
      this.zone.aboveMinutes = aboveZoneMinutes.toFixed(1)
      this.isSave = true
      this.$emit('saveIt')
    },
    save() {
      this.isDisabled = true
      this.$emit('save')
    },
    cancelled() {
      this.isDisabled = false
    },
    saved() {
      this.isDisabled = false
      this.isSave = false
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-range {
  font-size: 0.8em;
}
.custom-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  line-height: 90%;
}
</style>
